export enum EditUserContainerConstants {
  CLOSE_EDIT_USER_MODAL = '@EditUser/CLOSE_EDIT_USER_MODAL',
  CLOSE_EDIT_USER_MODAL_AND_RELOAD_USER_LIST = '@EditUser/CLOSE_EDIT_USER_MODAL_AND_RELOAD_USER_LIST',
  OPEN_EDIT_USER_MODAL = '@EditUser/OPEN_EDIT_USER_MODAL',

  GET_USER = '@EditUser/GET_USER',
  GET_USER_REQUEST = '@EditUser/GET_USER_REQUEST',
  GET_USER_REQUEST_SUCCESS = '@EditUser/GET_USER_REQUEST_SUCCESS',
  GET_USER_REQUEST_ERROR = '@EditUser/GET_USER_REQUEST_ERROR',

  EDIT_USER = '@EditUser/EDIT_USER',
  EDIT_USER_REQUEST = '@EditUser/EDIT_USER_REQUEST',
  EDIT_USER_REQUEST_SUCCESS = '@EditUser/EDIT_USER_REQUEST_SUCCESS',
  EDIT_USER_REQUEST_ERROR = '@EditUser/EDIT_USER_REQUEST_ERROR',
}
